export default {
  fromValue (val) {
    switch (val) {
      case 'car':
        return 'Carro'
      case 'motorcycle':
        return 'Moto'
      default:
        return val
    }
  }
}
